import type { DisplayPreferencesRecord, UserPreferences } from '../data/types';

export const defaultDisplayPreferences: DisplayPreferencesRecord = {
  darkMode: false,
  lightTableColor: '#ced4da',
  darkTableColor: '#4a4a4a',
  lightWallColor: '#ff0000',
  darkWallColor: '#ff0000',
};

export async function loadDisplayPreferencesForUser(
  preferences?: UserPreferences | null,
): Promise<DisplayPreferencesRecord> {
  return {
    darkMode: Boolean(preferences?.darkMode ?? defaultDisplayPreferences.darkMode),
    lightTableColor: preferences?.lightTableColor ?? defaultDisplayPreferences.lightTableColor,
    darkTableColor: preferences?.darkTableColor ?? defaultDisplayPreferences.darkTableColor,
    lightWallColor: preferences?.lightWallColor ?? defaultDisplayPreferences.lightWallColor,
    darkWallColor: preferences?.darkWallColor ?? defaultDisplayPreferences.darkWallColor,
  };
}
